import 'angular';

angular
  .module('services.RequestHelperService', [])
  .service('RequestHelperService', [
    '$q',
    function($q) {
      /**
       * Creates a promise and rejects it with the given error message
       *
       * @param error (string) - Error to reject the promise with
       *
       * @returns (object) - Rejected promise object
       */
      var rejectPromise = function(error) {
        return $q(function(resolve) {
          resolve($q.reject({
            'error': error
          }));
        });
      };

      return {
        'rejectPromise': rejectPromise
      };
    }
  ]);
